import { render, staticRenderFns } from "./UserReportInfo.vue?vue&type=template&id=48aafe5c&scoped=true&"
import script from "./UserReportInfo.vue?vue&type=script&lang=js&"
export * from "./UserReportInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserReportInfo.vue?vue&type=style&index=0&id=48aafe5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aafe5c",
  null
  
)

export default component.exports